import React, { useState, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Typography, Modal, Button, TextField } from '@mui/material'
import statusStore from '../../../stores/statusStore'
import logger from '../../../utils/logger'

// Утилита для перевода HEX-цвета в RGBA (для полупрозрачного фона тега)
function hexToRgba(hex, alpha = 0.5) {
	let c = hex.replace('#', '')
	if (c.length === 3) {
		c = c[0] + c[0] + c[1] + c[1] + c[2] + c[2]
	}
	const r = parseInt(c.slice(0, 2), 16)
	const g = parseInt(c.slice(2, 4), 16)
	const b = parseInt(c.slice(4, 6), 16)
	return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

// Стили для контента внутри модального окна
const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: 350,
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 4,
	borderRadius: 2,
}

const TagsList = observer(() => {
	const { tags } = statusStore
	const mayManage = statusStore.canManageDictionaries

	// Состояния для модального окна
	const [open, setOpen] = useState(false)
	const [editingTagId, setEditingTagId] = useState(null)
	const [editName, setEditName] = useState('')
	const [editColor, setEditColor] = useState('#000000')

	const colorInputRef = useRef(null)

	// Открыть модальное окно для редактирования выбранного тега
	const handleOpenModal = tag => {
		setEditingTagId(tag.id)
		setEditName(tag.name)
		setEditColor(tag.color)
		setOpen(true)
	}

	// Закрыть модальное окно (без сохранения)
	const handleCloseModal = () => {
		setOpen(false)
		setEditingTagId(null)
		setEditName('')
		setEditColor('#000000')
	}

	// Сохранить изменения
	const handleSave = async () => {
		if (!editName.trim()) {
			alert('Название тега не должно быть пустым')
			return
		}

		await statusStore.updateTag({
			id: editingTagId,
			name: editName,
			color: editColor,
		})

		handleCloseModal()
	}

	// Добавляем новый обработчик для удаления тега
	const handleDelete = async () => {
		if (window.confirm('Вы действительно хотите удалить этот тег?')) {
			await statusStore.deleteTag(editingTagId)
			handleCloseModal()
		}
	}

	// Обработка выбора цвета
	const handleColorChange = e => {
		setEditColor(e.target.value)
	}

	return (
		<Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
			{tags.map(tag => {
				const backgroundColor = hexToRgba(tag.color, 0.6)

				return (
					<Box
						key={tag.id}
						onClick={mayManage ? () => handleOpenModal(tag) : undefined}
						sx={{
							backgroundColor,
							borderRadius: '16px',
							paddingX: 2,
							paddingY: 0.5,
							display: 'inline-flex',
							alignItems: 'center',
							cursor: mayManage ? 'pointer' : 'default',
						}}
					>
						<Typography variant='body2' noWrap >
							{tag.name} ...
						</Typography>
					</Box>
				)
			})}

			{/* Модальное окно для редактирования */}
			{mayManage && <Modal
				open={open}
				onClose={handleCloseModal}
				aria-labelledby='edit-tag-modal'
				aria-describedby='modal-to-edit-tag'
			>
				<Box sx={modalStyle}>
					<Typography variant='h6' mb={2}>
						Редактирование тега
					</Typography>

					<TextField
						label='Название тега'
						value={editName}
						onChange={e => setEditName(e.target.value)}
						fullWidth
						margin='normal'
					/>

					<Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
						<Box
							sx={{
								width: 24,
								height: 24,
								borderRadius: '50%',
								backgroundColor: editColor,
								mr: 2,
							}}
						/>
						<Button
							variant='outlined'
							onClick={() => colorInputRef.current.click()}
						>
							Изменить цвет
						</Button>
						<input
							type='color'
							ref={colorInputRef}
							value={editColor}
							onChange={handleColorChange}
							style={{ display: 'none' }}
						/>
					</Box>

					<Box
						sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3, gap: 1 }}
					>
						<Button variant='outlined' onClick={handleDelete} color='error'>
							Удалить
						</Button>
						<Button variant='outlined' onClick={handleCloseModal}>
							Отмена
						</Button>
						<Button variant='contained' onClick={handleSave}>
							Сохранить
						</Button>
					</Box>
				</Box>
			</Modal>}
		</Box>
	)
})

export default TagsList
